import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import Config from "assets/configs/score.js"
import CumulativeBarChartTemplate from "views/molecules/charts/template/CumulativeBarChartTemplate"

const TRANSLATION_SCOPE =
  "score:score.13.chartDatacenterInternalEmissionsBreakdown"

export const findColorByValue = (value, total) => {
  const numericTotal = Number(total)
  const numericValue = Number(value)

  if (!numericTotal || Number.isNaN(numericTotal) || Number.isNaN(numericValue)) {
    return Config.common.colorsEvaluation.green
  }

  const ratio = numericValue / numericTotal
  if (ratio < 0.1) return Config.common.colorsEvaluation.green
  if (ratio < 0.2) return Config.common.colorsEvaluation.yellow

  return Config.common.colorsEvaluation.red
}

const valuesForColor = (dataset) =>
  dataset.data_before_conversion || dataset.data

const ChartODD13DatacenterInternalEmissionsBreakdownMolecule = ({
  breakdown,
}) => {
  const { t } = useTranslation()

  if (!breakdown?.datasets?.length) {
    return null
  }

  const { datasets, label_keys, unit } = breakdown

  // Numeric series for coloring (avoids JSON-string concatenation on sum)
  const colorSeries = datasets.map((dataset) =>
    valuesForColor(dataset).map((value) => Number(value) || 0)
  )
  const columnTotals = colorSeries[0].map((_, columnIndex) =>
    colorSeries.reduce((sum, series) => sum + series[columnIndex], 0)
  )

  const formattedDatasets = datasets.map((dataset, datasetIndex) => ({
    label: t(`${TRANSLATION_SCOPE}.${dataset.label}`),
    data: dataset.data,
    backgroundColor: colorSeries[datasetIndex].map((value, columnIndex) =>
      findColorByValue(value, columnTotals[columnIndex])
    ),
  }))

  return (
    <CumulativeBarChartTemplate
      shouldTranslateLabels={false}
      title={t(`${TRANSLATION_SCOPE}.title`)}
      datasets={formattedDatasets}
      labelPath={TRANSLATION_SCOPE}
      labelKeys={label_keys.map((labelKey) =>
        typeof labelKey === "string"
          ? labelKey
          : t(`${TRANSLATION_SCOPE}.${labelKey}`, { defaultValue: labelKey })
      )}
      unitPath={"units:units.emission"}
      unitKey={unit}
      hiddenLegend
      useBackgroundColorsInDatasets
      showLabelOnBar
      helpText={t(`${TRANSLATION_SCOPE}.help`)}
    />
  )
}

ChartODD13DatacenterInternalEmissionsBreakdownMolecule.propTypes = {
  breakdown: PropTypes.shape({
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        ),
        data_before_conversion: PropTypes.arrayOf(
          PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        ),
      })
    ),
    label_keys: PropTypes.array,
    unit: PropTypes.string,
  }),
}

ChartODD13DatacenterInternalEmissionsBreakdownMolecule.defaultProps = {
  breakdown: null,
}

export default ChartODD13DatacenterInternalEmissionsBreakdownMolecule
